import emailConfirmationApi, { type ConfirmationTokenDetails } from './emailConfirmationApi';

export { type ConfirmationTokenDetails };

export const {
    useResendEmailVerificationMutation,
    useChangeVerificationEmailMutation,
    useGetConfirmationTokenDetailsQuery,
} = emailConfirmationApi;

export default emailConfirmationApi;
